import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import globalReducer from "./slice/globalSlice";
import { rtkQueryErrorLogger } from "./middleware/rtkQueryErrorLogger ";
import { baseApi } from "../services/base";

export const store = configureStore({
	reducer: {
		// Add the generated reducer as a specific top-level slice
		[baseApi.reducerPath]: baseApi.reducer,
		global: globalReducer,
	},
	// Adding the api middleware enables caching, invalidation, polling,
	// and other useful features of `rtk-query`.
	// RTK 2 documents this callback as returning its Tuple type. The previous form
	// spread into a plain array, which RTK 2 still accepts at runtime (verified) —
	// the Tuple requirement is enforced by TypeScript types, and this project is
	// plain JavaScript. Using .concat() is the documented form and keeps the Tuple,
	// so it stays correct if this is ever migrated to TypeScript.
	// Order is unchanged: default middleware, baseApi.middleware, rtkQueryErrorLogger.
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware().concat(baseApi.middleware, rtkQueryErrorLogger),
});

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
